import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class TokenService {
  private readonly http = inject(HttpClient);

  getAccessToken(): string | null {
    return localStorage.getItem("accessToken");
  }

  getRefreshToken(): string | null {
    return localStorage.getItem("refreshToken");
  }

  setAccessToken(token: string): void {
    localStorage.setItem("accessToken", token);
  }

  setRefreshToken(token: string): void {
    localStorage.setItem("refreshToken", token);
  }

  clearTokens(): void {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  }

  refreshAccessToken(refreshToken: string): Observable<string> {
    return this.http
      .post<{
        data: { accessToken: string; refreshToken?: string };
      }>(`${environment.backendUrl}/auth/login`, { refreshToken })
      .pipe(
        tap((response) => {
          const { accessToken, refreshToken } = response.data;
          if (accessToken) this.setAccessToken(accessToken);
          if (refreshToken) this.setRefreshToken(refreshToken);
        }),
        map((response) => response.data.accessToken),
        catchError((err) => {
          this.clearTokens();
          return throwError(() => err);
        })
      );
  }
}
